<div class="hs-advanced-options">
  <div class="form-floating mb-3">
    <input class="form-control" name="folder" [(ngModel)]="data.folder_name"
      [placeholder]="'ADDLAYERS.folderName' | translateHs  " />
    <label for="folder" class="capabilities_label control-label">{{'ADDLAYERS.folderName' | translateHs
      }}</label>
  </div>
  <div class="form-group" *ngIf="isKml">
    <input type="checkbox" name="extractStyles" [(ngModel)]="data.extract_styles" />
    <label class="capabilities_label control-label ms-1">{{'ADDLAYERS.VECTOR.extractStyles' |
      translateHs }}</label>
  </div>
  <hs-target-position [(addUnder)]="data.addUnder"></hs-target-position>
  <div class="d-flex flex-row justify-content-between align-items-baseline mb-1 ps-4" *ngIf="data.loadAsType">
    {{'ADDDATA.loadAs' | translateHs }}
    <div class="btn-group ms-2">
      <button type="button" class="btn btn-light btn-outline-secondary" (click)="data.loadAsType = 'wms'"
        [ngClass]="{'active': data.loadAsType === 'wms'}">
        WMS
      </button>
      <button type="button" class="btn btn-light btn-outline-secondary" (click)="data.loadAsType = 'wfs'"
        [ngClass]="{'active': data.loadAsType === 'wfs'}">
        WFS
      </button>
    </div>
  </div>
</div>